import { useState } from "react";
import { X, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
export default function EmailCaptureForm({ onClose }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    // TODO: integrate with email marketing API (e.g. Mailchimp, ConvertKit)
    // For now, just show success state
    setSubmitted(true);
  };

  return (
    <div
      className="w-full max-w-[480px] mx-auto bg-zinc-950 border border-zinc-800 rounded-2xl p-8 relative shadow-2xl shadow-black/60"
      role="dialog"
      aria-modal="true"
      aria-label={t('email_capture_form.email_capture_popup')}
    >
      {/* Close button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 p-2 text-zinc-500 hover:text-white transition-colors rounded-full hover:bg-zinc-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
        aria-label={t('email_capture_form.close_popup')}
      >
        <X className="w-5 h-5" />
      </button>

      {submitted ? (
        /* ---- Success State ---- */
        <div className="text-center py-6">
          <CheckCircle className="w-12 h-12 text-amber-500 mx-auto mb-4" aria-hidden="true" />
          <h3 className="text-xl font-bold text-white mb-2">
            🎉 Guide sent! Check your inbox (and spam folder).
          </h3>
          <Link
            to="/pricing"
            className="inline-block mt-4 text-amber-500 hover:text-amber-400 text-sm font-medium transition-colors underline underline-offset-4"
            onClick={onClose}
          >
            While you're here, start your free trial →
          </Link>
        </div>
      ) : (
        /* ---- Form State ---- */
        <div>
          <h2 className="text-2xl font-bold text-white mb-1 tracking-tight">
            WAIT — GET THE FREE AI AGENT SETUP GUIDE
          </h2>
          <p className="text-zinc-400 text-sm mb-6">
            Learn how to deploy your first AI agent in 5 minutes. Free PDF + video walkthrough.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (error) setError("");
              }}
              placeholder={t('email_capture_form.seu_melhor_email')}
              required
              aria-label={t('email_capture_form.email_address')}
              aria-invalid={error ? "true" : "false"}
              className="w-full rounded-xl border border-zinc-800 bg-zinc-900 px-4 py-3 text-sm text-white outline-none placeholder:text-zinc-600 focus:border-amber-500 focus-visible:ring-2 focus-visible:ring-amber-500 transition-colors"
            />
            {error && (
              <p className="mt-2 text-xs text-red-400" role="alert">{error}</p>
            )}

            <button
              type="submit"
              className="w-full mt-4 rounded-xl bg-amber-500 px-4 py-3 text-sm font-bold text-black uppercase tracking-wider transition-colors hover:bg-amber-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            >
              SEND ME THE GUIDE →
            </button>
          </form>

          <p className="mt-4 text-xs text-zinc-500 text-center">
            🔒 Spam-free. Unsubscribe anytime. Join 33+ businesses.
          </p>
        </div>
      )}
    </div>
  );
}
